import { createStore, applyMiddleware } from 'redux'
import ReduxThunk from 'redux-thunk'
import rootReducer from './reducers/rootReducer'
import { composeWithDevTools } from 'redux-devtools-extension'

let middleware = [ReduxThunk];

export const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(...middleware)));
